import styled from 'styled-components';

export const Bold = styled.p`
  margin: 0;
  text-align: left;
  font-weight: bold;
`;

export const Sub = styled.p`
  margin: 0;
  text-align: left;
`;
